import { Tab } from './components/common/BackgroundSelectorView';
import { ColorType } from './components/common/ColorSelectorView';
import globalEvents = require('diy/util/globalEvents');

export interface SectionKpiEventData {
    pageName?: string;
    appendProps?: string;
}

export interface SectionKpiEvent {
    type: SectionKpiEventsTypes;
    trackingType: string;
    data?: SectionKpiEventData;
}

const trackAsPage = 'diy-tracking-section-page';
const trackAsPageClosed = 'diy-tracking-section-page-closed';
const trackAsMenu = 'diy-tracking-section-menu';
const trackAsLink = 'diy-tracking-section-link';

export enum SectionKpiEventsTypes {
    Open,
    Close,
    MainTab,
    GroupsTab,
    DesignTab,
    LayoutChanged,
    ToggleContent,
    BackgroundNone,
    BackgroundColor,
    BackgroundSwatch,
    BackgroundTheming,
    BackgroundCustomColor,
    BackgroundImage,
    BackgroundEditImage,
    BackgroundApplyOnAll,
    ManageGroupsOpen,
    ManageGroupsClose,
    ManageGroupsBackground,
    FullWidthChanged,
    StyleChanged,
    RoundnessChanged,
    ColumnsChanged,
    ColumnsFitChanged,
    AddGroup,
    DeleteGroup
}

let eventList: SectionKpiEvent[] = [
    {
        type: SectionKpiEventsTypes.Open,
        trackingType: trackAsPage,
        data: {
            appendProps: "open"
        }
    },
    {
        type: SectionKpiEventsTypes.Close,
        trackingType: trackAsPageClosed,
        data: {
            appendProps: "close"
        }
    },
    {
        type: SectionKpiEventsTypes.MainTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "mainTab"
        }
    },
    {
        type: SectionKpiEventsTypes.DesignTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "designTab"
        }
    },
    {
        type: SectionKpiEventsTypes.GroupsTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "groupsTab"
        }
    },
    {
        type: SectionKpiEventsTypes.LayoutChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "layoutChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ToggleContent,
        trackingType: trackAsLink,
        data: {
            appendProps: "toggleContent"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundNone,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToNone"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundColor,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToColor"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundSwatch,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToColorSwatch"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundTheming,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToTheming"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundCustomColor,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToCustomColor"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundImage,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToImage"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundEditImage,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundEditedImage"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsOpen,
        trackingType: trackAsMenu,
        data: {
            appendProps: "openManageGroups"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsClose,
        trackingType: trackAsMenu,
        data: {
            appendProps: "mainTab"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsBackground,
        trackingType: trackAsMenu,
        data: {
            appendProps: "manageGroupsBackground"
        }
    },
    {
        type: SectionKpiEventsTypes.FullWidthChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "fullWidthChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.StyleChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "styleChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.RoundnessChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "RoundnessChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ColumnsChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "ColumnsChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ColumnsFitChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "ColumnsFitChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.AddGroup,
        trackingType: trackAsLink,
        data: {
            appendProps: "AddGroup"
        }
    },
    {
        type: SectionKpiEventsTypes.DeleteGroup,
        trackingType: trackAsLink,
        data: {
            appendProps: "DeleteGroup"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundApplyOnAll,
        trackingType: trackAsLink,
        data: {
            appendProps: "BackgroundApplyOnAll"
        }
    }
];

let eventsByType = new Map<SectionKpiEventsTypes, SectionKpiEvent>();
eventList.forEach((event) => eventsByType.set(event.type, event));

export let events = eventsByType;

export function emitKpiEvent(eventType: SectionKpiEventsTypes, appendProps?: string) {
    let event: SectionKpiEvent = eventsByType.get(eventType);
    let data: SectionKpiEventData = Object.assign({}, event.data);

    if (appendProps && appendProps.length) {
        data.appendProps += ':' + appendProps;
    }

    globalEvents.trigger(event.trackingType, data);
}

export function trackBackgroundColorClicked(colorType: ColorType, value?: string) {
    switch (colorType) {
        case ColorType.Swatch:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundSwatch);
            break;
        case ColorType.Custom:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundCustomColor);
            break;
        case ColorType.Theming:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundTheming);
            break;
        default:
    }
}

export function trackBackgroundTabClicked(tab: Tab) {
    switch (tab) {
        case Tab.None:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundNone);
            break;
        case Tab.Image:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundImage);
            break;
        case Tab.Color:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundColor);
            break;
        default:
    }
}

export function trackManageGroupBackgroundClicked() {
    emitKpiEvent(SectionKpiEventsTypes.ManageGroupsBackground);
}

export function trackBackgroundImageEdited() {
    emitKpiEvent(SectionKpiEventsTypes.BackgroundEditImage);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/tracking.ts
 **/